import { SubpropertyModel } from '@modules/subproperty/subproperty-model';

const { fields } = SubpropertyModel;

export default [
  fields.name,
  fields.status,
  fields.logos,
];
